import { createRequestTypes } from '../../../../redux/actions/utils';

export const GET_DATA_STORAGE = createRequestTypes('GET_DATA_STORAGE');
export const getDataStorage = (params) => ({ type: GET_DATA_STORAGE.REQUEST, params});

export const GET_DATA_FILE = createRequestTypes('GET_DATA_FILE');
export const getDataFile = (params) => ({type: GET_DATA_FILE.REQUEST, params});

export const LOGOUT = 'LOGOUT';
export const logout = () => ({ type: LOGOUT});